import { render } from "./ProfileDetails.vue?vue&type=template&id=a76aefc4"
import script from "./ProfileDetails.vue?vue&type=script&lang=js"
export * from "./ProfileDetails.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__